import { loadVisualElementController } from './loadVisualElement';
import { ContainerState } from '@sas-dvr/internal-va-react-core/store/birdElement/containerState';
import { VisualElementControllerLoader } from './LoaderFactory';

export const loadVisualContainerElementController: VisualElementControllerLoader = (
  controller,
  elementController,
  unload$,
  myActions$,
  state$,
  deps,
  lifecyleActions
) => {
  const key = deps.getKey(elementController);
  return loadVisualElementController(
    controller,
    elementController,
    unload$,
    myActions$,
    state$,
    deps,
    lifecyleActions ?? {
      create: () => ContainerState.actions.add(key, {}),
      delete: () => ContainerState.actions.delete(key),
    }
  );
};
